angular.module('eCareVault.common.crSelector', []);
